import request from '@/utils/request'


//查询列表
export function newsList(data) {
  return request({
    url: '/admin/storeNews/list',
    method: 'post',
    data:data
  })
}

//添加轮训图
export function newsAdd(data) {
  return request({
    url: '/admin/storeNews/add',
    method: 'post',
    data:data
  })
}

//删除
export function newsInActiveById(params) {
  return request({
    url: '/admin/storeNews/inActiveById',
    method: 'get',
    params: params
  })
}





// WEBPACK FOOTER //
// ./src/api/storeFrontNews.js